<template>
  <div>"Oops! This page doesn't exist. Maybe you made a typo?"</div>
</template>

<script>
export default {};
</script>

<style></style>
